//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"ConeAngle",1,0],[0,"DestinationPosition",1,"Point",0],[0,"Intensity",1,0],[0,"LightShadowType",1,0],[0,"LightType",1,0],[0,"SourcePosition",1,"Point",0],[0,"UseWithAdvancedStudioImageBasedLighting",1,0],[0,"UseWithIbl",1,1],[0,"UseWithRayTracedImageBasedLighting",1,0]],[],[]];
SPLM.Display.LightBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.LightBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.LightBuilder.ShadowType = Object.freeze({
    "None" : "None", "SoftEdged" : "SoftEdged", "HardEdged" : "HardEdged", "TranslucentHard" : "TranslucentHard"});

SPLM.Display.LightBuilder.LightMode = Object.freeze({
    "FixedToObserver" : "FixedToObserver", "FixedToThePart" : "FixedToThePart"});

export default SPLM;